import { IFiltersActivated } from './filters-activated.model';
import { IFilterValue } from './filters.model';
import { IParameterizable, IQueryParams } from './page-service';

export class FiltersLatestActivation implements IParameterizable {
    activatedFilters: IFiltersActivated;

    constructor(activatedFilter: IFiltersActivated) {
        this.activatedFilters = activatedFilter;
    }

    generateParams(): IQueryParams {
        return {
            queryString: 'latest_activated_filters',
            params: [
                {
                    id: this.activatedFilters.id,
                    value: this.activatedFilters.values
                        .map((value: IFilterValue) => value.id)
                        .join(','),
                },
            ],
        };
    }
}
